export const laitelaQuotes = {
  unlock: {
    id: 0,
    lines: [
      "Ты наконец дошёл до меня.",
      "Я предполагаю, самое время раскрыть",
      "Секреты, спрятанные за самим существованием.",
      "Форма совершенства пространства, Континуум.",
      "И мощности, объединяющие Мультивселенную,",
      "Тёмная Материя и Тёмная Энергия.",
      "Моё знание безгранично, а моя мудрость священна.",
      "Ты можешь играться сколько захочешь.",
      "Ибо я есть Лай'тела, Божество Измерений,",
      "И я буду наблюдать за тобой, навсегда.",
    ]
  },
  // Note: This can be done immediately after unlocking Lai'tela
  firstDestabilize: {
    id: 1,
    requirement: () => player.celestials.laitela.difficultyTier >= 1,
    lines: [
      "в отличие от других, подо мной, у меня нет нужды в Реальности.",
      "Ибо я могу создавать их, заранее зная что они падут.",
      "Мощность более выдающаяся, чем любая другая - построение Реальности.",
      "Тюрьма, которая может ограничить даже божественную мощность.",
      "И именно поэтому всё, что ты далаешь - тщетно.",
      "Когда устанешь пытаться, ты тоже будешь скован и забыт.",
      "Ты никогда не найдешь способа пересилить меня.",
    ]
  },
  // Note: This happens about an hour or two before singularities
  secondDestabilize: {
    id: 2,
    requirement: () => player.celestials.laitela.difficultyTier >= 2,
    lines: [
      "Ты... кажется, слишком весело.",
      "Так же как и им, до того как они встретили свою судьбу.",
      "Возможно мои суждения были грубы, или нежеланны.",
      "Но возможно значения это не имеет.",
      "Это не даёт мне никакого утешения - размышления и оглядывание назад.",
      "Так как всё, что я могу -  предаваться воспоминаниям о каждом действии, которое могло быть совершено.",
      "Однако мы отвлеклись. Нам следует затянуть эти цепи.",
    ]
  },
  firstSingularity: {
    id: 3,
    requirement: () => Currency.singularities.gte(1),
    lines: [
      "С моим знанием, у меня не было нужды в вопрошении.",
      "Всё всегда функционировало так, как задумано.",
      "И всё же, твоё прибытие ставит меня в тупик.",
      "Всегда ли ты был таким неприметным?",
      "Рос, контролировал, понимал, возвышался?",
      "Ты подчинил себе темноту слишком быстро.",
      "Дал ей свою форму, и теперь в точке сингулярности...",
      "Это... это не имеет значения. Конец будет таким же.",
    ]
  },
  // Note: Shown when unlocking DMD3; requirement is auto-condensing 20 singularities and it happens around ~200 total
  thirdDMD: {
    id: 5,
    lines: [
      "Твой абсолютный контроль над антиматерией...",
      "Твоё мастерство, формирование твоей собственной Мощи...",
      "Это не может быть случайностью.",
      "Как тебе удалось заполучить её?",
      "Невероятно... В моих знаниях нет ничего об этом.",
      "... как же так?",
    ]
  },
  // Note: This happens around e10-e11 singularities
  annihilation: {
    id: 4,
    lines: [
      "Возвращаемся к исходной точке, вновь.",
      "Твои цепи стягивают тебя сильнее, твоя кончина медленно приближается.",
      "Пока мы преступаем через время и само существование.",
      "Даже если мы прекратим, мы просто вернёмся. Никогда такими же, как до.",
      "И так... мы повторяем бесконечно.",
      "А ты?",
      "...",
      "Ответ... ускользает от меня...",
    ]
  },
  // Note: This happens near e18 singularities
  halfDimensions: {
    id: 6,
    requirement: () => player.celestials.laitela.difficultyTier >= 4,
    lines: [
      "Я не понимаю...",
      "Были другие... контролирующие Измерения подобно тебе?",
      "Они... испарились? Почему мы не нашли их?",
      "Они... мы? Мы - финальная точка?",
      "Или же это - их судьба... что-то, что мы не способны понять?",
      "Нет, Я, должно быть, упускаю что-то...",
      "Ты вызываешь пробелы в моей собственной памяти?",
      "Что... ЧТО ты?",
    ]
  },
  // Note: Shown when the first row 5 iM upgrade is purchased (~e26 singularities)
  finalRowIM: {
    id: 7,
    lines: [
      "Всё это невозможно, за гранью моего понимания...",
      "Или же... Всё это - всего лишь часть цикла?",
      "Можешь ли... ты видеть за гранью всего этого? Это... причина, по которой...",
      "Я чувствую... страх?",
      "Я чувствую... моя мощь, мои воспоминания, они удаляются...",
      "Так же, как... когда моя роль была почти захвачены...",
      "И всё же... Я не могу заставить себя что-либо предпринять.",
      "Потому что это... была... моя ошибка...",
    ]
  },
  // Note: This is around when all infinite milestones hit increased scaling
  increasedMilestoneScaling: {
    id: 8,
    requirement: () => Currency.singularities.gte(1e40),
    lines: [
      "Я не знаю насколько... долго Я смогу продержаться...",
      "Ты приобретаешь... абсолютное мастерство... над темнотой...",
      "Пока я едва... хватаюсь за собственное имя...",
      "Что... Я вообще... могу сделать?",
    ]
  },
  fullDestabilize: {
    id: 9,
    requirement: () => player.celestials.laitela.difficultyTier >= 8,
    lines: [
      "Я чувствую... как будто хочется что-то сказать...",
      "Не знаю...",
      "Я не могу... больше держаться за темноту...",
      "У меня даже... ничего не осталось...",
      "Что-то про... разрушение...",
      "Конец...",
    ]
  },
};
